import { z } from "zod";
import { ClientGenderEnum, ContracTypeEnum } from "./clientEnum";
import moji from "moji";
import { isAnyKatakana } from "@/lib/utils";

export const ClientSearchSchema = z.object({
  page: z.number().optional().catch(1),
  limit: z.number().optional().catch(10),
  clientName: z.string().optional(),
  clientNameKana: z.string().optional(),
});

export const ClientPathSchema = z.object({
  clientId: z.coerce.number().int(),
});

export const ClientCreateSchema = z
  .object({
    clientName: z
      .string()
      .min(1, "名義は必須です。")
      .transform((val) => {
        const removedSpace = val.replace(/[\s\u3000]+/g, "");
        return moji(removedSpace)
          .convert("HE", "ZE")
          .convert("HK", "ZK")
          .toString();
      }),
    clientNameKana: z
      .string()
      .min(1, "名義カナは必須です。")
      .transform((val) => {
        const removedSpace = val.replace(/[\s\u3000]+/g, "");
        return moji(removedSpace)
          .convert("HE", "ZE")
          .convert("HK", "ZK")
          .toString();
      })
      .refine((val) => isAnyKatakana(val), {
        message: "カタカナで入力してください",
      }),
    contractType: z.enum(ContracTypeEnum),
    gender: z.enum(ClientGenderEnum),
    birthDate: z.string(),
  })
  .check((ctx) => {
    if (ctx.value.contractType == ContracTypeEnum.Individual) {
      if (!ctx.value.birthDate) {
        ctx.issues.push({
          code: "custom",
          message: "生年月日は必須です。",
          input: ctx.value,
          path: ["birthDate"],
        });
      }
      if (!ctx.value.gender) {
        ctx.issues.push({
          code: "custom",
          message: "性別は必須です。",
          input: ctx.value,
          path: ["gender"],
        });
      }
    }
  });

export type ClientCreateForm = z.infer<typeof ClientCreateSchema>;

export const ClientUpdateSchema = z
  .object({
    clientName: z
      .string()
      .min(1, "名義は必須です。")
      .transform((val) => {
        const removedSpace = val.replace(/[\s\u3000]+/g, "");
        return moji(removedSpace)
          .convert("HE", "ZE")
          .convert("HK", "ZK")
          .toString();
      }),
    clientNameKana: z
      .string()
      .min(1, "名義カナは必須です。")
      .transform((val) => {
        const removedSpace = val.replace(/[\s\u3000]+/g, "");
        return moji(removedSpace)
          .convert("HE", "ZE")
          .convert("HK", "ZK")
          .toString();
      })
      .refine((val) => isAnyKatakana(val), {
        message: "カタカナで入力してください",
      }),
    contractType: z.enum(ContracTypeEnum),
    gender: z.enum(ClientGenderEnum),
    birthDate: z.string(),
  })
  .check((ctx) => {
    if (ctx.value.contractType == ContracTypeEnum.Individual) {
      if (!ctx.value.birthDate) {
        ctx.issues.push({
          code: "custom",
          message: "生年月日は必須です。",
          input: ctx.value,
          path: ["birthDate"],
        });
      }
      if (!ctx.value.gender) {
        ctx.issues.push({
          code: "custom",
          message: "性別は必須です。",
          input: ctx.value,
          path: ["gender"],
        });
      }
    }
  });

export type ClientUpdateForm = z.infer<typeof ClientUpdateSchema>;
